<template>
	<ion-modal
		:is-open="showModal"
		:can-dismiss="!showModal"
		:backdrop-dismiss="false"
		:keyboard-close="false"
	>
		<ion-header>
			<ion-toolbar color="branding">
				<ion-title>{{ t("user-agreement.user-agreement") }}</ion-title>
			</ion-toolbar>
		</ion-header>

		<ion-content class="ion-padding">
			<!-- Logo -->
			<div class="flex w-full justify-center p-6">
				<img
					class="h-32 object-contain p-3 drop-shadow-[0px_1px_1px_rgba(0,0,0,0.4)]"
					:src="gvaLogo"
				/>
			</div>

			<div class="user-agreement-content mb-4">
				<p><strong>Welcome to GeoVisual Analytics.</strong></p>
				<p>
					GeoVisual Technologies, Inc., a Colorado corporation doing
					business as GeoVisual Analytics (“<strong>we</strong>”,
					“<strong>us</strong>”, or “<strong>GVA</strong>”), provides
					and deploys on a bespoke basis Analytical and Operational
					Agricultural Software, Specialized Sensors, GNSS hardware,
					Manned and Unmanned Aerial Systems and operators for
					purposes of agricultural crop planning, monitoring, task
					scheduling, and data analysis (collectively, the “GVA
					Services”) to customers, subject to the following conditions
					and terms of use (the “<strong>Terms of Use</strong>”). By
					using GVA Services, you agree to these Terms of Use.
				</p>
				<p>
					<strong
						>These Terms of Use are important and affect your legal
						rights, please read them carefully.</strong
					>
				</p>
				<p>
					<strong>Protection and Disclosure of Information</strong>.
					Any information that you or we have disclosed or may
					disclose to the other party (“<strong
						>Confidential Information</strong
					>”) shall be subject to the terms below and any separate
					executed Mutual Non-Disclosure Agreement between you and GVA
					(“<strong>NDA</strong>”).
				</p>
				<ol>
					<li>
						<strong>Ownership of Confidential Information.</strong>
						The Originating Party retains all right, title and
						interest in all Confidential Information it discloses
						under this Agreement. Notwithstanding the foregoing, the
						parties mutually agree and acknowledge that each party
						is, and during the term of this Agreement will be,
						independently engaged in the continued improvement and
						development of goods, and services;
					</li>
					<li>
						<strong>
							Non-disclosure and non-use of confidential
							information.
						</strong>
						All Confidential Information (as defined below) will be
						kept confidential by the Receiving Party and will not be
						disclosed, furnished, transferred, displayed or
						otherwise used, directly or indirectly, without the
						prior written consent of the Originating Party, for any
						purpose other than the Authorized Use (as defined
						below). A Receiving Party shall protect the Originating
						Party’s Confidential Information by using at least the
						same degree of care, but no less than reasonable care,
						to prevent the unauthorized use, disclosure or
						publication of the Confidential Information as the
						Receiving Party uses to protect its own Confidential
						Information of like nature. Upon the Originating Party’s
						written request, the Receiving Party will promptly
						return to the Originating Party or destroy (as
						requested) all copies (including electronic copies) of
						any Confidential Information held by the Receiving Party
						and its Representatives and any notes or other documents
						incorporating any Confidential Information, except that
						the Receiving Party shall be entitled to retain one
						paper copy in its legal files subject to the provisions
						hereof.
					</li>
					<li>
						“<strong>Confidential Information</strong>” means any
						non-public business or technical information or data of
						a party, including but not limited to, any information
						relating to such party’s product or service plans,
						product and service prices, historical records and
						production data, finances, financing structure or
						investments, business or financial strategies, marketing
						plans, business opportunities and strategies, research
						and development, inventions, intellectual property data,
						customers, partners, alliance members, suppliers, an
						individual’s information protected by the California
						Privacy Rights Act or the European CDPR, weaknesses, or
						other proprietary information of any type that is
						valuable to the Originating Party because of the fact
						that it is not generally known or accessible to others.
						All Confidential Information may be specifically marked
						as Confidential by the Originating Party at the time of
						disclosure or, if disclosed orally, shall be orally
						designated as confidential and thereafter identified as
						confidential by written or electronic notice to the
						Receiving Party not later than thirty days following
						oral disclosure.
					</li>
				</ol>
				<p>
					GVA provides the GVA Services to customers pursuant to a
					separate service addendum (a “<strong
						>Service Addendum</strong
					>”) to these Terms of Use, which contains pricing
					information, service details, and other additional
					information. Any terms and conditions in a Service Addendum
					are in addition to the terms and conditions in these Terms
					of Use.
				</p>
				<p>
					<strong>Electronic Communications.</strong> When you use
					certain GVA Services, or send e-mails to us, you are
					communicating with us electronically, and you consent to
					receive communications from us electronically. We may
					communicate with you by e-mail, by posting notices on our
					websites, by delivering notifications through our mobile
					applications or through other electronic means. You agree
					that all agreements, notices, disclosures and other
					communications that we provide to you electronically satisfy
					any legal requirement that such communications be in
					writing.
				</p>
				<p>
					<strong>Billing and Payment.</strong> Unless otherwise
					provided in a Service Addendum, (i) we will invoice you on a
					bi-weekly basis for GVA Services provided during that
					period, and (ii) payment terms are net due upon invoice.
				</p>
				<p>
					<strong>Use of Printed Reports, and Analytic Files.</strong>
					You hereby acknowledge that: (a) you will be delivered
					analytics in the form of printed or computer-readable files
					(“Files”) containing processed data; (b) the Reports and
					Files are copyrighted subject matter; and (c) GVA or its
					licensors own and reserve to themselves and their successors
					all right, title and interest in any and all copyrights in
					the Analytical reports and Files.
				</p>
				<p>
					<strong>Mutual License:</strong> Except as other provided,
					subject to your compliance with all of the terms and
					conditions contained in these Terms of Use and any service
					addendum(s), GVA hereby grants you a personal, exclusive,
					non-assignable, non-transferable, and revocable, license for
					commercial purposes, to (i) reproduce the Analytical Reports
					and Files and to use computer software with which the Files
					are compatible; (ii) produce and reproduce images (“Images”)
					and analysis from the Files in any format for your own
					business; and (iii) with GVA agreement to make reports and
					analytics files produced therefrom available to third
					parties for use in directing equipment such as automated
					weeders, automated variable rate fertilizers, or automated
					harvesters providing services to or obtaining services from
					such parties in the normal course of your business. You
					shall not make any Files or Images available to third
					parties except as expressly permitted herein. You may not
					transfer or assign the rights and licenses granted under
					these Terms of Use without GVA's prior written consent,
					except to a successor to all or substantially all of your
					business assets who agrees in writing to be bound by these
					Terms of Use, subject to GVA’s reasonable approval. Your use
					of the Files and Images is subject to license and use
					restrictions of any third-party intellectual property
					integrated into or constituting part of the Files or Images.
					GVA reserves all rights not expressly granted to you under
					these Terms of Use. By using GVA Services, you agree to
					grant GVA an exclusive, perpetual, limited license to use
					any data, materials, analyses, records, or other information
					provided by you to GVA in connection with the GVA Services
					to (a) produce Files and Images, and (b) develop and improve
					GVA’s software, technology, platform and services. Except as
					expressly set forth above, there are no implied licenses
					granted under these Terms of Use or any service addendum.
				</p>
				<p>
					<strong>Ownership.</strong> You hereby acknowledge that GVA
					shall maintain all right, title, and interest in and to all
					technical information, know-how, copyrights, models,
					drawings, specifications, prototypes, inventions, raw data
					including point clouds and images, hardware and software
					developed by GVA personnel (the “GVA Intellectual
					Property”). Neither these Terms of Use (nor your access to
					the GVA Intellectual Property, GVA Services or GVA’s
					customer platform) transfers to you or any third party any
					rights, title or interest in or to the GVA Intellectual
					Property, except for the limited access rights expressly set
					forth above under “Mutual License.”
				</p>
				<p>
					<strong>Equitable Relief.</strong> You acknowledge that
					Confidential Information is unique and that breach of your
					confidentiality obligations with respect to Confidential
					Information will cause irreparable damage to GVA that is
					impossible to quantify in monetary terms. Accordingly, you
					consent to GVA obtaining equitable or injunctive relief
					against any threatened or actual breach of the terms of
					these Terms of Use without posting a bond or other security
					and you hereby waive any right to argue that GVA has an
					adequate remedy at law.
				</p>
				<p>
					<strong>Changes.</strong> These Terms of Use are subject to
					occasional revision, and if we make any substantial changes,
					we may notify you by sending you an e-mail to the last
					e-mail address you provided to us (if any), and/or by
					prominently posting notice of the changes on our platform.
					You are responsible for providing us with your most current
					e-mail address. In the event that the last e-mail address
					that you have provided us is not valid, or for any reason is
					not capable of delivering to you the notice described above,
					our dispatch of the e-mail containing such notice will
					nonetheless constitute effective notice of the changes
					described in the notice. Any changes to these Terms of Use
					will be effective upon the earlier of thirty (30) calendar
					days following our dispatch of an e-mail notice to you (if
					applicable) or thirty (30) calendar days following our
					posting of notice of the changes on our customer platform.
					These changes will be effective immediately for new
					customers of GVA. Continued use of GVA Services following
					notice of such changes shall indicate your acknowledgement
					of such changes and agreement to be bound by the terms and
					conditions of such changes.
				</p>
				<p>
					<strong>Liability and Indemnification.</strong> You and we
					each agree to defend, indemnify, and hold harmless the other
					party, including each of their respective officers,
					directors, and shareholders from and against all claims of
					third parties, and all associated losses, to the extent
					arising out of (a) a party’s negligence or willful
					misconduct in performing any of its obligations under this
					agreement, or (b) a material breach by a party of any of its
					representations, warranties, covenants or agreements under
					these Terms of Use or any Service Addendum. If both parties
					are liable for damages to a third party, the parties shall
					apportion liability based upon their respective level of
					fault. Neither party shall be liable to the other party for
					any consequential damages in connection with this Agreement.
					Notwithstanding the foregoing, in no event will the
					liability of either Party exceed the total amounts payable
					under these Terms of Use and any accompanying Service
					Addendum.
				</p>
				<p>
					<strong>Insurance.</strong> We will, at our sole cost and
					expense, procure and maintain, or require our
					sub-contractors to acquire commercial general liability and
					unmanned aerial systems (UAS) insurance adequate for any UAS
					services provided as part of the GVA Services.
				</p>
				<p>
					<strong>Governing Law.</strong> These Terms of Use shall be
					governed by and construed in accordance with the laws of the
					State of Colorado. You hereby consent to the exclusive
					jurisdiction of any State or Federal Courts located in
					Denver, Colorado. You agree that you will not knowingly take
					or fail to take any action that might cause you to be in
					violation of any law or regulation of the United States,
					including the United States Foreign Corrupt Practices Act.
				</p>
				<p>
					<strong>Assignment.</strong> Your rights and obligations
					hereunder cannot be transferred or assigned in whole or in
					part without the prior written consent of GVA.
				</p>
				<p>
					<strong>Other Terms.</strong> In the event that any of the
					terms or conditions in these Terms of Use are held by a
					court or other tribunal of competent jurisdiction to be
					unenforceable, you agree that the remaining portions hereof
					shall remain in full force and effect. These Terms of Use,
					together with any Service Addendum and any NDA, constitute
					the full and entire understanding between you and us, and
					supersedes all previous understandings or discussions,
					whether written or oral, between you and us regarding the
					subject matter hereof and thereof. You agree that no failure
					or delay by GVA in enforcing any right will be deemed a
					waiver.
				</p>
			</div>
			<ion-footer>
				<form @submit.prevent="() => submit()">
					<ion-button
						expand="block"
						type="submit"
						:disabled="submitting"
						color="primary"
					>
						{{ t("user-agreement.agree-and-continue") }}
					</ion-button>
				</form>
			</ion-footer>
		</ion-content>
	</ion-modal>
</template>

<script setup lang="ts">
	import {
		IonModal,
		IonHeader,
		IonToolbar,
		IonFooter,
		IonTitle,
		IonButton,
		IonContent,
	} from "@ionic/vue";
	import { useI18n } from "vue-i18n";
	import { ref, watch } from "vue";
	import { useMyUser } from "seedgreen-shared/queries/user";
	import { sendToast } from "@/utils/sendToast";
	import seedgreenAPI from "@/utils/seedgreen-api";
	import { AxiosError } from "axios";
	import { captureException } from "@sentry/vue";
	import { useVerifyToken } from "seedgreen-shared/query/verify-token";

	const { t } = useI18n();

	const { myUser, refetch: refetchUser } = useMyUser();
	const { tokenValid, refetch: refetchToken } = useVerifyToken();
	const showModal = ref(false);
	const submitting = ref(false);

	const gvaLogo = ref("/images/branding/logo-color.png");

	watch(myUser, () => {
		// check if the user has accepted the user agreement
		// only if myUser has the userAgreementDate property (not always true)
		if (
			tokenValid.value &&
			myUser.value &&
			Object.keys(myUser.value).includes("needsToSignAgreement")
		) {
			if (!myUser.value.needsToSignAgreement) {
				showModal.value = false;
			} else {
				showModal.value = true;
			}
		}
	});

	const submit = async () => {
		if (!navigator.onLine) {
			await sendToast("No network connection detected", 3000, "error");
			throw new Error("You must be online to log out");
		}

		try {
			submitting.value = true;
			const result = await seedgreenAPI.put("v2/User/UserAgreement");
			if (result.status === 200) {
				await sendToast("User agreement accepted", 3000, "success");

				// refresh the token validity
				// refresh the user data
				await refetchToken();
				await refetchUser();

				showModal.value = false;
			} else {
				await sendToast(
					"Error accepting user agreement",
					3000,
					"error",
				);
			}
		} catch (error) {
			// Ignore 401 errors - user is already logged out
			if ((error as AxiosError).status != 401) {
				console.error("Error accepting user agreement:", error);
				captureException(error);
			}
		} finally {
			submitting.value = false;
		}
	};
</script>
